import { gql } from '@apollo/client';

export const GET_PROSPECTS = gql`
  query Prospects(
    $name: String
    $offset: Int
    $limit: Int
    $orderBy: String
    $orderDirection: String
    $category: [String]
  ) {
    brands(
      name: $name
      offset: $offset
      limit: $limit
      orderBy: $orderBy
      orderDirection: $orderDirection
      category: $category
      isProspect: true
    ) {
      status
      code
      error
      count
      data {
        id
        name
        cif
        address
        payment_terms
        profile_picture
        createdAt
        updatedAt
        campaignCount
        category
        sector
        source
        is_prospect
      }
    }
  }
`;

export const GET_PROSPECT = gql`
  query Prospect($brandId: String!) {
    brand(brandId: $brandId) {
      status
      code
      error
      data {
        id
        name
        cif
        address
        companyName
        paymentTerms
        profilePicture
        holdedIdSpain
        holdedIdAndorra
        billingEmail
        isProspect
        category
        sector
        source
        referralName
        accountManager {
          id
          brandId
          userId
          createdAt
          user {
            id
            name
            email
            profilePicture
          }
        }
        users {
          id
          name
          blocked
          last_login
          email
          title
          profilePicture
        }
        groups {
          id
          name
          users
        }
      }
    }
  }
`;
